import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { ApiDataService } from "src/app/service/api-data.service";
import * as NotificationActions from "../notification/notification.actions";
import * as EmailNotificationSettingsActions from "./email-notification-settings.actions";

@Injectable()
export class EmailNotificationSettingsEffects {
    private actions$ = inject(Actions);
    private apiDataService = inject(ApiDataService);

    loadSettings$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmailNotificationSettingsActions.loadSettings),
            mergeMap(() =>
                this.apiDataService.getEmailNotificationSettings().pipe(
                    map((settings) =>
                        EmailNotificationSettingsActions.loadSettingsSuccess({
                            settings,
                        }),
                    ),
                    catchError((error) =>
                        of(
                            EmailNotificationSettingsActions.loadSettingsFailure({
                                error: error.message,
                            }),
                            NotificationActions.errorNotification({
                                errorMessage: `Failed to load email notification settings: ${error.message}`,
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );

    updateSetting$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmailNotificationSettingsActions.updateSetting),
            mergeMap((action) =>
                this.apiDataService
                    .updateEmailNotificationSetting(
                        action.eventCode,
                        action.isEnabled,
                    )
                    .pipe(
                        map((setting) =>
                            EmailNotificationSettingsActions.updateSettingSuccess({
                                setting,
                            }),
                        ),
                        catchError((error) =>
                            of(
                                EmailNotificationSettingsActions.updateSettingFailure({
                                    eventCode: action.eventCode,
                                    error: error.message,
                                }),
                                NotificationActions.errorNotification({
                                    errorMessage: `Failed to update email notification setting for ${action.eventCode}: ${error.message}`,
                                }),
                            ),
                        ),
                    ),
            ),
        ),
    );
}
